import { motion } from "framer-motion";
import { Compass, RefreshCcw, Globe2, Sparkles } from "lucide-react";
import { useT } from "@/lib/LanguageContext";

const ICONS = [Compass, RefreshCcw, Globe2, Sparkles];

export default function ChangeSignals() {
  const { t } = useT();
  const s = t.signals;

  return (
    <section
      id="senales"
      data-testid="change-signals-section"
      className="relative py-24 md:py-36 bg-[#F3D9C8] vk-grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24 items-end">
          <div className="col-span-12 md:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.24em] text-[#6B4E6F] mb-6">
              {s.eyebrow}
            </p>
            <h2
              data-testid="change-signals-headline"
              className="font-serif font-light text-[clamp(2.2rem,5vw,4.5rem)] leading-[0.95] tracking-tight"
            >
              {s.headline.l1}
              <br />
              {s.headline.l2}
              <br />
              <span className="italic">{s.headline.l3}</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <p className="text-lg leading-relaxed text-[#6B4E6F]">{s.lead}</p>
            <p className="mt-5 text-base leading-relaxed text-[#6B4E6F]">{s.body}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#4B2F4F]/10">
          {s.blocks.map((b, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                data-testid={`change-signal-${i}`}
                className="group relative bg-[#F7F3F7] p-10 md:p-12 min-h-[220px] hover:bg-[#4B2F4F] transition-colors duration-500"
              >
                <Icon
                  size={28}
                  strokeWidth={1.2}
                  className="text-[#E0B25B] mb-8 transition-transform duration-500 group-hover:-translate-y-1"
                />
                <h3 className="font-serif text-2xl md:text-3xl leading-tight tracking-tight text-[#4B2F4F] group-hover:text-[#F7F3F7] transition-colors duration-500">
                  {b.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-[#6B4E6F] group-hover:text-[#F7F3F7]/80 transition-colors duration-500">
                  {b.text}
                </p>
                <span className="absolute top-10 right-10 font-serif text-sm tracking-[0.2em] text-[#4B2F4F]/30 group-hover:text-[#F7F3F7]/30 transition-colors duration-500">
                  0{i + 1}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
